import Controller from '@ember/controller';
import { reads } from 'macro-decorators';

export default class DeliveriesGetStartedController extends Controller {
  @reads('model.deliveriesSubscription.onExpiredTrial') isOnExpiredDeliveriesTrial;
}
